import { MemoEntryMode } from '@/types/schema';
import { formatDateToMMDDYY } from '@/utils/formatting/dates';

export interface MemoAttributionParams {
  createdAt: Date;
  updatedAt: Date;
  entryMode?: MemoEntryMode | null;
  updateUserDisplayName: string;
}

export function getMemoAttributionDate({
  createdAt,
  updatedAt,
  entryMode,
}: Pick<MemoAttributionParams, 'createdAt' | 'updatedAt' | 'entryMode'>) {
  if (entryMode === MemoEntryMode.User) {
    return updatedAt;
  }

  return createdAt;
}

export function getMemoAttributionText({
  createdAt,
  updatedAt,
  entryMode,
  updateUserDisplayName,
  includeDate = true,
}: MemoAttributionParams & { includeDate?: boolean }) {
  const attributionDate = formatDateToMMDDYY(
    getMemoAttributionDate({
      createdAt,
      updatedAt,
      entryMode,
    })
  );

  if (entryMode === MemoEntryMode.User) {
    if (!includeDate) {
      return `Edited by ${updateUserDisplayName || 'Unknown user'}`;
    }

    return `Edited by ${updateUserDisplayName || 'Unknown user'} on ${attributionDate}`;
  }

  if (!includeDate) {
    return 'Generated by AI';
  }

  return `Generated by AI on ${attributionDate}`;
}
